export default __webpack_public_path__ + "static/media/Encuentranos_facebook_fibromialgia_positivo.3bbb4a72.jpeg";